import React from 'react'

export default function FormIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='8px'
      height='10px'
      viewBox='0 0 8 10'
      fill='currentColor'
      {...props}
    >
      <path d='M1.9875 7.875H6.0125V7.125H1.9875V7.875ZM1.9875 5.75H6.0125V5H1.9875V5.75ZM0.75 10C0.55 10 0.375 9.925 0.225 9.775C0.075 9.625 0 9.45 0 9.25V0.75C0 0.55 0.075 0.375 0.225 0.225C0.375 0.075 0.55 0 0.75 0H5.2625L8 2.7375V9.25C8 9.45 7.925 9.625 7.775 9.775C7.625 9.925 7.45 10 7.25 10H0.75ZM4.8875 3.075V0.75H0.75V9.25H7.25V3.075H4.8875Z' />
    </svg>
  )
}
